import { Typogaphy } from 'vnetwork-ui'
import { NotificationItem as NotificationItemType } from '../..'
import dayjs from 'dayjs'
import { useNavigate } from 'react-router-dom'
import { doc, updateDoc } from 'firebase/firestore'
import { db } from '@/configs/firebase'
import { useTranslation } from 'react-i18next'
import MessageCircleIcons from '@/icons/MessageCircleIcons'
import ClockIcons from '@/icons/ClockIcons'

interface NotificationItemProps {
    item: NotificationItemType
    handleClosePopup: () => void
}

const NotificationItem: React.FC<NotificationItemProps> = ({
    item,
    handleClosePopup,
}) => {
    const navigate = useNavigate()
    const ref = doc(db, `notifications/${item?.id}`)
    const { t } = useTranslation()

    return (
        <div
            onClick={() => {
                navigate(item?.link)

                if (!item?.read)
                    updateDoc(ref, {
                        ...item,
                        read: true,
                    })

                handleClosePopup()
            }}
            className={`p-4 border-b border-gray-50 hover:bg-blue-50 transition-colors duration-200 flex gap-3 items-start cursor-pointer ${!item?.read ? 'bg-blue-25 border-l-2 border-l-blue-400' : ''}`}
        >
            <div className="flex-shrink-0 mt-1">
                <MessageCircleIcons
                    className={`w-5 h-5 ${!item?.read ? 'text-blue-600' : 'text-gray-400'}`}
                />
            </div>

            <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                    <Typogaphy
                        className={`font-medium text-sm leading-5 ${!item?.read ? 'text-gray-900' : 'text-gray-700'}`}
                    >
                        {t(item?.title)}
                    </Typogaphy>
                </div>

                <Typogaphy
                    dangerouslySetInnerHTML={{ __html: t(item?.body) }}
                    className="text-xs text-gray-600 leading-4 mb-2 line-clamp-2"
                />

                <div className="inline-flex items-center">
                    <span className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded-full font-medium flex items-center gap-1">
                        <ClockIcons className="w-3 h-3" />
                        {dayjs(item?.created_at?.toDate())?.fromNow()}
                    </span>
                </div>
            </div>

            {!item?.read && (
                <div className="w-2 h-2 rounded-full bg-blue-500 mt-1 flex-shrink-0" />
            )}
        </div>
    )
}

export default NotificationItem
